import * as React from 'react';
import { observer, inject } from 'mobx-react';
import LoggedinUser from '../../models/LoggedinUser';
import SubscriptionOverview from '../../components/subscriptionoverview/SubscriptionOverview';
import Footer from '../../components/footer/Footer';


interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class Home extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  componentDidMount() {
    window.scrollTo(0, 0);    
}

  render() {

    return (
      <div className="container">

        <br />
        <div className="row">
          <div>
            <SubscriptionOverview loggedinUser={this.props.loggedinUser} />
          </div>
        </div>
        <div className="footerDiv">
          <Footer loggedinUser={this.props.loggedinUser} />
        </div>
      </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/home/Home.tsx